import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=0297bd6c&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"
import style0 from "./theme.vue?vue&type=style&index=0&id=0297bd6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297bd6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0297bd6c')) {
      api.createRecord('0297bd6c', component.options)
    } else {
      api.reload('0297bd6c', component.options)
    }
    module.hot.accept("./theme.vue?vue&type=template&id=0297bd6c&scoped=true", function () {
      api.rerender('0297bd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents/theme.vue"
export default component.exports